import api from './api';

const userService = {

  getAll: async () => {
    const res = await api.get('/users');
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/users/${id}`);
    return res.data;
  },

  create: async (data) => {
    const res = await api.post('/users', data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/users/${id}`, data);
    return res.data;
  },

  changePassword: async (id, newPassword) => {
    const res = await api.patch(`/users/${id}/password`, { newPassword });
    return res.data;
  },

  toggleStatus: async (id) => {
    const res = await api.patch(`/users/${id}/toggle-status`);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/users/${id}`);
    return res.data;
  },
};

export default userService;